import { TeacherBusyFormValues } from '../components/CalendarEvent/TeacherBusyEventForm';
import { CreateTeacherBusyReq } from '../services/teacher-busy.types';
import { buildRecurrence } from './classes';

export async function buildCreateTeacherBusy(
  data: TeacherBusyFormValues
): Promise<CreateTeacherBusyReq> {
  const recurrenceData = buildRecurrence(data);

  const createTeacherBusyReq: CreateTeacherBusyReq = {
    ...recurrenceData,
  };

  return createTeacherBusyReq;
}
